import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { AutoScrollAnchor } from '../../../../styled-components/shared';
import { Licences, type Licence } from '../../../../types/common';
import { PromotionStatuses, type PromotionStatus } from '../../../../types/promotions';
import BoomBannerContainer from '../../../boom/components/BoomBanner/BoomBannerContainer';
import GRBannerContainer from '../../../gift-race/containers/GRBannerContainer';
import KLBannerContainer from '../../../koh-lanta/containers/KLBannerContainer';
import MPBannerContainer from '../../../monopoly/containers/MPBannerContainer';
import MissionsCardsListContainer from '../MissionsCardsList/MissionCardsListContainer';

export const EXTRAS_ROUTE_ANCHOR_ID = 'extras-route-anchor';

const bannersSharedStyle = css`
  margin: 1em 1em 0.3em;
`;

const StyledKLBannerContainer = styled(KLBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledGRBannerContainer = styled(GRBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledMPBannerContainer = styled(MPBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledBoomBannerContainer = styled(BoomBannerContainer)`
  ${bannersSharedStyle}
`;

const Wrapper = styled.div``;

type MissionsProps = {
  className?: string;
  licence?: Licence;
  promotionStatus: PromotionStatus;
  didReceivedUserData: boolean;
};

const Missions = ({ className = '', licence, promotionStatus, didReceivedUserData }: MissionsProps) => {
  const showOperationBanners = useMemo(
    () => licence === Licences.ES && (promotionStatus !== PromotionStatuses.DEFAULT || !didReceivedUserData),
    [didReceivedUserData, licence, promotionStatus],
  );

  return (
    <Wrapper className={className}>
      <AutoScrollAnchor data-anchorid={EXTRAS_ROUTE_ANCHOR_ID} />

      {showOperationBanners ? (
        <>
          <StyledKLBannerContainer />
          <StyledGRBannerContainer />
          <StyledMPBannerContainer />
          <StyledBoomBannerContainer />
        </>
      ) : null}

      <MissionsCardsListContainer />
    </Wrapper>
  );
};

export default Missions;
